export const messages = {
  en: {
    businessOpportunityManageMessages: {
      search: {
        title: 'Search Conditions',
        opportunityName: 'Opportunity Name',
        opportunityNamePlaceholder: 'Please enter opportunity name',
        customerName: 'Customer Name',
        customerNamePlaceholder: 'Please enter customer name',
        source: 'Opportunity Source',
        sourcePlaceholder: 'Please select source',
        status: 'Opportunity Status',
        statusPlaceholder: 'Please select status',
        responsiblePerson: 'Responsible Person',
        responsiblePersonPlaceholder: 'Please select person',
        expectedDealDateStart: 'Expected Deal Date (Start)',
        expectedDealDateEnd: 'Expected Deal Date (End)',
        priority: 'Priority',
        priorityPlaceholder: 'Please select priority',
        startTime: 'Create Time (Start)',
        endTime: 'Create Time (End)',
        searchBtn: 'Search',
        resetBtn: 'Reset'
      },
      list: {
        title: 'Business Opportunity Management',
        addBtn: 'Add Opportunity',
        editBtn: 'Edit',
        detailBtn: 'Detail',
        deleteBtn: 'Delete',
        batchDeleteBtn: 'Batch Delete',
        exportBtn: 'Export Data',
        refreshBtn: 'Refresh'
      },
      table: {
        opportunityName: 'Opportunity Name',
        customerName: 'Customer Name',
        source: 'Opportunity Source',
        status: 'Opportunity Status',
        expectedValue: 'Expected Value (CNY)',
        responsiblePerson: 'Responsible Person',
        expectedDealDate: 'Expected Deal Date',
        priority: 'Priority',
        createTime: 'Create Time',
        updateTime: 'Update Time',
        operation: 'Operation'
      },
      add: {
        title: 'Add Business Opportunity',
        opportunityName: 'Opportunity Name',
        opportunityNamePlaceholder: 'Required, please enter opportunity name',
        customerName: 'Customer Name',
        customerNamePlaceholder: 'Required, please select customer',
        source: 'Opportunity Source',
        sourcePlaceholder: 'Required, please select source',
        status: 'Opportunity Status',
        statusPlaceholder: 'Required, please select status',
        expectedValue: 'Expected Value (CNY)',
        expectedValuePlaceholder: 'Required, please enter amount (≥0)',
        responsiblePerson: 'Responsible Person',
        responsiblePersonPlaceholder: 'Required, please select person',
        expectedDealDate: 'Expected Deal Date',
        expectedDealDatePlaceholder: 'Required, please select date',
        priority: 'Priority',
        priorityPlaceholder: 'Required, please select priority',
        description: 'Opportunity Description',
        descriptionPlaceholder: 'Optional, please enter description (≤500 characters)',
        attachments: 'Related Attachments',
        attachmentTip: 'Support doc, docx, xls, xlsx, pdf, jpg, png (max 3 files)',
        saveBtn: 'Save',
        cancelBtn: 'Cancel'
      },
      edit: {
        title: 'Edit Business Opportunity',
        opportunityName: 'Opportunity Name',
        opportunityNamePlaceholder: 'Required, please enter opportunity name',
        customerName: 'Customer Name',
        customerNamePlaceholder: 'Required, please select customer',
        source: 'Opportunity Source',
        sourcePlaceholder: 'Required, please select source',
        status: 'Opportunity Status',
        statusPlaceholder: 'Required, please select status',
        expectedValue: 'Expected Value (CNY)',
        expectedValuePlaceholder: 'Required, please enter amount (≥0)',
        responsiblePerson: 'Responsible Person',
        responsiblePersonPlaceholder: 'Required, please select person',
        expectedDealDate: 'Expected Deal Date',
        expectedDealDatePlaceholder: 'Required, please select date',
        priority: 'Priority',
        priorityPlaceholder: 'Required, please select priority',
        description: 'Opportunity Description',
        descriptionPlaceholder: 'Optional, please enter description (≤500 characters)',
        attachments: 'Related Attachments',
        attachmentTip: 'Support doc, docx, xls, xlsx, pdf, jpg, png (max 3 files)',
        originalAttachment: 'Original Attachments',
        saveBtn: 'Save',
        cancelBtn: 'Cancel'
      },
      detail: {
        title: 'Business Opportunity Detail',
        opportunityName: 'Opportunity Name',
        customerName: 'Customer Name',
        source: 'Opportunity Source',
        status: 'Opportunity Status',
        expectedValue: 'Expected Value (CNY)',
        responsiblePerson: 'Responsible Person',
        expectedDealDate: 'Expected Deal Date',
        priority: 'Priority',
        description: 'Opportunity Description',
        attachments: 'Related Attachments',
        createTime: 'Create Time',
        updateTime: 'Update Time',
        closeBtn: 'Close'
      },
      delete: {
        title: 'Confirm Deletion',
        confirmText: 'Are you sure to delete this opportunity? This operation cannot be undone!',
        batchConfirmText: 'Are you sure to delete selected {count} opportunities? This operation cannot be undone!',
        confirmBtn: 'Confirm Delete',
        cancelBtn: 'Cancel'
      },
      option: {
        source: {
          customer_introduce: 'Customer Referral',
          marketing: 'Marketing Promotion',
          website: 'Official Website',
          social_media: 'Social Media',
          other: 'Others'
        },
        status: {
          initial_contact: 'Initial Contact',
          demand_confirmation: 'Demand Confirmation',
          solution_making: 'Solution Development',
          business_negotiation: 'Business Negotiation',
          closed_won: 'Closed (Won)',
          closed_lost: 'Closed (Lost)'
        },
        priority: {
          high: 'High',
          medium: 'Medium',
          low: 'Low'
        },
        yesNo: {
          yes: 'Yes',
          no: 'No'
        }
      },
      validate: {
        opportunityNameRequired: 'Opportunity name is required',
        opportunityNameMax: 'Opportunity name cannot exceed 100 characters',
        customerNameRequired: 'Customer name is required',
        sourceRequired: 'Opportunity source is required',
        statusRequired: 'Opportunity status is required',
        expectedValueRequired: 'Expected value is required',
        expectedValueMin: 'Expected value cannot be less than 0',
        responsiblePersonRequired: 'Responsible person is required',
        expectedDealDateRequired: 'Expected deal date is required',
        priorityRequired: 'Priority is required',
        descriptionMax: 'Description cannot exceed 500 characters',
        attachmentMax: 'Maximum 3 attachments allowed',
        fileFormatError: 'Unsupported file format, please select doc, docx, xls, xlsx, pdf, jpg, png'
      },
      message: {
        loadSuccess: 'Data loaded successfully',
        loadFailed: 'Failed to load data',
        loadUserFailed: 'Failed to load responsible person list',
        loadCustomerFailed: 'Failed to load customer list',
        saveSuccess: 'Opportunity saved successfully',
        saveFailed: 'Failed to save opportunity',
        updateSuccess: 'Opportunity updated successfully',
        updateFailed: 'Failed to update opportunity',
        deleteSuccess: 'Opportunity deleted successfully',
        deleteFailed: 'Failed to delete opportunity',
        uploadSuccess: 'File uploaded successfully',
        uploadFailed: 'File upload failed',
        fileLimit: 'Maximum 3 attachments allowed',
        noSelectData: 'Please select data first',
        operateSuccess: 'Operation successful',
        operateFailed: 'Operation failed',
        confirmDelete: 'Please confirm deletion',
        networkError: 'Network error, please try again later'
      },
      common: {
        unknown: 'Unknown',
        noData: 'No data',
        download: 'Download',
        delete: 'Delete',
        view: 'View',
        reset: 'Reset',
        exportSuccess: 'Export started, please wait',
        exportFailed: 'Export failed, please try again'
      }
    },

  },
  zh: {
    businessOpportunityManageMessages: {
      search: {
        title: '查询条件',
        opportunityName: '商机名称',
        opportunityNamePlaceholder: '请输入商机名称',
        customerName: '客户名称',
        customerNamePlaceholder: '请输入客户名称',
        source: '商机来源',
        sourcePlaceholder: '请选择商机来源',
        status: '商机状态',
        statusPlaceholder: '请选择商机状态',
        responsiblePerson: '负责人',
        responsiblePersonPlaceholder: '请选择负责人',
        expectedDealDateStart: '预计成交日期(开始)',
        expectedDealDateEnd: '预计成交日期(结束)',
        priority: '优先级',
        priorityPlaceholder: '请选择优先级',
        startTime: '创建时间(开始)',
        endTime: '创建时间(结束)',
        searchBtn: '查询',
        resetBtn: '重置',
        keyword: '输入客户名称和商机名称'
      },
      list: {
        title: '商机管理',
        addBtn: '新增商机',
        editBtn: '编辑',
        detailBtn: '详情',
        deleteBtn: '删除',
        batchDeleteBtn: '批量删除',
        exportBtn: '导出数据',
        refreshBtn: '刷新'
      },
      table: {
        opportunityName: '商机名称',
        customerName: '客户名称',
        source: '商机来源',
        status: '商机状态',
        expectedValue: '需求面积',
        responsiblePerson: '负责人',
        expectedDealDate: '预计成交日期',
        priority: '优先级',
        createTime: '创建时间',
        updateTime: '更新时间',
        operation: '操作'
      },
      add: {
        title: '新增商机',
        opportunityName: '商机名称',
        opportunityNamePlaceholder: '必填，请输入商机名称',
        customerName: '客户名称',
        customerNamePlaceholder: '必填，请选择客户',
        source: '商机来源',
        sourcePlaceholder: '必填，请选择商机来源',
        status: '商机状态',
        statusPlaceholder: '必填，请选择商机状态',
        expectedValue: '需求面积',
        expectedValuePlaceholder: '必填，请输入需求面积',
        responsiblePerson: '负责人',
        responsiblePersonPlaceholder: '必填，请选择负责人',
        expectedDealDate: '预计成交日期',
        expectedDealDatePlaceholder: '必填，请选择日期',
        priority: '优先级',
        priorityPlaceholder: '必填，请选择优先级',
        description: '客户要求描述',
        descriptionPlaceholder: '选填，请输入描述(≤500字)',
        attachments: '相关附件',
        attachmentTip: '支持doc、docx、xls、xlsx、pdf、jpg、png格式（最多3个文件）',
        saveBtn: '保存',
        negotiationProgress: '谈判进度',
        roomId: "房间",
        industryType: "行业类型",
        opportunityType: "商机类型",
        cancelBtn: '取消'
      },
      edit: {
        title: '编辑商机',
        opportunityName: '商机名称',
        opportunityNamePlaceholder: '必填，请输入商机名称',
        customerName: '客户名称',
        customerNamePlaceholder: '必填，请选择客户',
        source: '商机来源',
        sourcePlaceholder: '必填，请选择商机来源',
        status: '商机状态',
        statusPlaceholder: '必填，请选择商机状态',
        expectedValue: '预计价值(元)',
        expectedValuePlaceholder: '必填，请输入金额(≥0)',
        responsiblePerson: '负责人',
        responsiblePersonPlaceholder: '必填，请选择负责人',
        expectedDealDate: '预计成交日期',
        expectedDealDatePlaceholder: '必填，请选择日期',
        priority: '优先级',
        priorityPlaceholder: '必填，请选择优先级',
        description: '客户要求描述',
        descriptionPlaceholder: '选填，请输入描述(≤500字)',
        attachments: '相关附件',
        attachmentTip: '支持doc、docx、xls、xlsx、pdf、jpg、png格式（最多3个文件）',
        originalAttachment: '原有附件',
        saveBtn: '保存',
        cancelBtn: '取消'
      },
      detail: {
        title: '商机详情',
        opportunityName: '商机名称',
        customerName: '客户名称',
        source: '商机来源',
        status: '商机状态',
        expectedValue: '预计价值(元)',
        responsiblePerson: '负责人',
        expectedDealDate: '预计成交日期',
        priority: '优先级',
        description: '客户要求描述',
        attachments: '相关附件',
        createTime: '创建时间',
        updateTime: '更新时间',
        closeBtn: '关闭'
      },
      delete: {
        title: '确认删除',
        confirmText: '确定要删除该商机吗？此操作不可撤销！',
        batchConfirmText: '确定要删除选中的{count}条商机吗？此操作不可撤销！',
        confirmBtn: '确认删除',
        cancelBtn: '取消'
      },
      view: {
        title: '商机详情'
      },
      option: {
        source: {
          customer_introduce: '客户介绍',
          marketing: '市场推广',
          website: '官网咨询',
          social_media: '社交媒体',
          other: '其他'
        },
        status: {
          initial_contact: '初步接触',
          demand_confirmation: '需求确认',
          solution_making: '方案制定',
          business_negotiation: '商务谈判',
          closed_won: '已成交',
          closed_lost: '已流失'
        },
        priority: {
          high: '高',
          medium: '中',
          low: '低'
        },
        yesNo: {
          yes: '是',
          no: '否'
        }
      },
      validate: {
        opportunityNameRequired: '请输入商机名称',
        opportunityNameMax: '商机名称不能超过100个字符',
        customerNameRequired: '请选择客户名称',
        sourceRequired: '请选择商机来源',
        statusRequired: '请选择商机状态',
        expectedValueRequired: '请输入预计价值',
        expectedValueMin: '预计价值不能小于0',
        responsiblePersonRequired: '请选择负责人',
        expectedDealDateRequired: '请选择预计成交日期',
        priorityRequired: '请选择优先级',
        descriptionMax: '客户要求描述不能超过500个字符',
        attachmentMax: '最多只能上传3个附件',
        fileFormatError: '不支持的文件格式，请选择doc、docx、xls、xlsx、pdf、jpg、png格式'
      },
      message: {
        loadSuccess: '数据加载成功',
        loadFailed: '数据加载失败',
        loadUserFailed: '负责人列表加载失败',
        loadCustomerFailed: '客户列表加载失败',
        saveSuccess: '商机保存成功',
        saveFailed: '商机保存失败',
        updateSuccess: '商机更新成功',
        updateFailed: '商机更新失败',
        deleteSuccess: '商机删除成功',
        deleteFailed: '商机删除失败',
        uploadSuccess: '文件上传成功',
        uploadFailed: '文件上传失败',
        fileLimit: '最多只能上传3个附件',
        noSelectData: '请先选择数据',
        operateSuccess: '操作成功',
        operateFailed: '操作失败',
        confirmDelete: '请确认是否删除',
        networkError: '网络异常，请稍后重试'
      },
      common: {
        unknown: '未知',
        noData: '暂无数据',
        download: '下载',
        delete: '删除',
        view: '查看',
        reset: '重置',
        exportSuccess: '导出已开始，请等待',
        exportFailed: '导出失败，请重试',
        noAttachment: '无'
      }
    },
  }
};